let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("KgFPE")).then(() => parcelRequire('l9JRb'));